const state = {
    palletInformationFields: [
        {
            key: "pallet_code",
            label: "棧板NO",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "pallet_name",
            label: "棧板名稱",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "runcard_code",
            label: "流程卡號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "box_start",
            label: "箱\n起始",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "number_end",
            label: "號\n結束",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "mantissa_box_remain",
            label: "尾數箱號\n餘量",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "total_number_boxes",
            label: "總箱數\n(含餘量箱)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        // {
        //     key: "board_details",
        //     label: "併板明細",
        //     sortable: false,
        //     class: "font-family-dfyuanstd-w5 table-col-hight"
        // },
        {
            key: "pallet_weight",
            label: "棧板總重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    palletInformationItem: [
        // {
        //     pallet_code: "16",
        //     pallet_name: "木質處理棧板(二手) 120x80c14.4(F.REYHER 專用棧板)",
        //     box_start: 1,
        //     number_end: 200,
        //     mantissa_box_remain: "-",
        //     total_number_boxes: 200,
        //     board_details: "-",
        //     pallet_weight: 585,
        // },
        // {
        //     pallet_code: "17",
        //     pallet_name: "木質處理棧板(二手) 120x80c14.4(F.REYHER 專用棧板)",
        //     box_start: 201,
        //     number_end: 310,
        //     mantissa_box_remain: "-",
        //     total_number_boxes: 110,
        //     board_details: "-",
        //     pallet_weight: 321.75,
        // },
        // {
        //     pallet_code: "",
        //     pallet_name: "",
        //     box_start: "",
        //     number_end: "",
        //     mantissa_box_remain: "",
        //     total_number_boxes: "",
        //     board_details: "總計",
        //     pallet_weight: 906.75,
        // }
    ],
}
const getters = {
    get_palletInformationFields: state => {
        return state.palletInformationFields
    },
    get_palletInformationItem: state => {
        return state.palletInformationItem
    },
}
const actions = {
    set_palletInformationFields(context, array) {
        context.commit('SET_PALLETINFORMATIONFIELDS', array);
    },
    set_palletInformationItem(context, array) {
        context.commit('SET_PALLETINFORMATIONITEM', array);
    },
    clear_palletInformationItem(context) {
        context.commit('CLEAR_PALLETINFORMATIONITEM');
    },
}
const mutations = {
    SET_PALLETINFORMATIONFIELDS(state, array) {
        state.palletInformationFields = array;
    },
    SET_PALLETINFORMATIONITEM(state, array) {
        state.palletInformationItem = array;
    },
    CLEAR_PALLETINFORMATIONITEM(state) {
        state.palletInformationItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/palletInformation.js